import {
  GET_GOLF_COURSE_SLOTS,
  GET_GOLF_COURSE_SLOTS_SUCCESS,
  GET_GOLF_COURSE_SLOTS_ERROR,
  GET_GOLF_COURSE_SLOTS_EMPTY,
} from './../../actionType.js';

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const GolfCourseSlots = (state = initialState, action) => {
  switch (action.type) {
    case GET_GOLF_COURSE_SLOTS:
      state = {
        ...state,
        // data: null,
        loading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case GET_GOLF_COURSE_SLOTS_SUCCESS:
      state = {
        ...state,
        data: action.payload,
        loading: false,
        success: true,
        error: false,
        message: null,
      };
      break;

    case GET_GOLF_COURSE_SLOTS_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: action.payload,
      };
      break;

    case GET_GOLF_COURSE_SLOTS_EMPTY:
      state = {
        ...initialState,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default GolfCourseSlots;
